import React, { useContext, useEffect, useState } from 'react';
import Button from '../../components/shared/custom-btn';
import CustomInput from '../../components/shared/custom-input';
import { RxCross2 } from 'react-icons/rx';
import TabToggle from '../../components/shared/tab-toggle';
import DateTimeLocalInput from '../../components/shared/datetime-input';
import CustomTextarea from '../../components/shared/custom-textarea';
import CustomReactSelect from '../../components/shared/custom-react-selector';
import ModalHeading from '../../components/shared/modal-heading';
import { prependDefault } from '../../utils/structure-options-utils';
import { AccountsContext } from '../../components/context/account-context';
import { ApiResponseMessage } from '../../components/shared/api-response';
import { localDateTimeToUTC } from '../../utils/set-date-range-utils';
import { createServices } from '../../services/services-service';
import Loader from '../../components/shared/loader';


const AddModal = ({ vehicle, handleCloseAddModal, onAdd, fetchGlobalData, globalDataloading, openEditModal, types, fetchServices, vendors, vehicles, isVehicleEditable = true }) => {
    const { accountId, attributes } = useContext(AccountsContext);

    const [formData, setFormData] = useState({
        vehicleId: vehicle ? vehicle.vehicleId : '',
        serviceTime: '',
        vendor: '',
        types: [],
        odometer: '',
        amount: '',
        note: '',
        taxOption: 'Include',
        taxPercentage: '13',
    });
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState({ message: '', type: '' });

    const calculatedAmount = () => {
        const baseAmount = parseFloat(formData.amount) || 0;
        if (formData.taxOption === 'Exclude' && formData.taxPercentage) {
            const taxPercent = parseFloat(formData.taxPercentage) || 0;
            const tax = (baseAmount * taxPercent) / 100;
            return (baseAmount + tax).toFixed(2);
        }
        return baseAmount.toFixed(2);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setApiResponse({ message: '', type: '' });
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption ? selectedOption.value : ''
        }));
        setApiResponse({ message: '', type: '' });
    };

    // handler for multi-select
    const handleMultiSelectChange = (selectedOptions, { name }) => {
        setFormData(prev => ({
            ...prev,
            [name]: selectedOptions ? selectedOptions.map(opt => opt.value) : []
        }));
        setApiResponse({ message: '', type: '' });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (loading || apiResponse.type === 'success') return;
        setLoading(true);
        setApiResponse({ message: '', type: '' });
        try {
            const baseAmount = parseFloat(formData.amount) || 0;
            let finalAmount = baseAmount;
            if (formData.taxOption === 'Exclude' && formData.taxPercentage) {
                const taxPercent = parseFloat(formData.taxPercentage) || 0;
                const tax = (baseAmount * taxPercent) / 100;
                finalAmount = baseAmount + tax;
            }
            const serviceData = {
                vehicleId: formData.vehicleId,
                serviceTime: localDateTimeToUTC(formData.serviceTime),
                vendorId: formData.vendor,
                types: formData.types,
                odometer: parseInt(formData.odometer),
                amount: finalAmount,
                note: formData.note,
                ...(formData.taxOption === 'Exclude' && { taxPercentage: parseFloat(formData.taxPercentage) })
            };
            const response = await createServices(serviceData, accountId);
            console.log(response)
            if (response.success) {
                setApiResponse({ message: 'Service record created successfully!', type: 'success' });
                const newItem = response.data.data;
                onAdd?.(newItem);
                fetchServices?.('Services');
                openEditModal?.(newItem);
                setTimeout(() => {
                    handleCloseAddModal();
                }, 1000);

            } else {
                setApiResponse({
                    message: response.data.message || 'Failed to create service record',
                    type: 'error'
                });
            }
        } catch (error) {
            setApiResponse({
                message: error.message || 'An unexpected error occurred',
                type: 'error'
            });
        } finally {
            setLoading(false);
        }
    };
    const vendorOptions = prependDefault(vendors.map(v => ({ value: v.vendorId, label: v.label })), 'Vendor');
    const vehicleOptions = prependDefault(vehicles.map(v => ({ value: v.vehicleId, label: v.label })), 'Vehicle');
    const typeOptions = prependDefault(types.map(v => ({ value: v.slug, label: v.label })), 'Types');

    useEffect(() => {
        if (typeof fetchGlobalData === 'function') {
            fetchGlobalData();
        }
    }, [])

    return (
        <form onSubmit={handleSave} className="space-y-2 pt-3 relative">
            <ModalHeading className="text-left mb-3 border-b border-gray-300 px-4 pb-2">
                Add Service Detail
            </ModalHeading>

            <button
                className='hover:scale-105 absolute -top-2 right-2 bg-white border p-2 rounded-full'
                onClick={handleCloseAddModal}
                disabled={loading}
            >
                <RxCross2 className='text-xl' />
            </button>

            <ApiResponseMessage response={apiResponse} />

            {
                globalDataloading ?
                    <Loader />
                    : (!vehicles || vehicles.length === 0) ? (
                        <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
                            <p className="text-gray-600 text-lg mb-2">There are no vehicles in your account.</p>
                            <p className="text-gray-500">Please create a vehicle to start using this feature.</p>
                        </div>
                    ) :
                        <>
                            <div className="grid grid-cols-1 sm:grid-cols-2 px-4 gap-y-1.5 gap-x-2">
                                <DateTimeLocalInput
                                    label="Service Time"
                                    name="serviceTime"
                                    value={formData.serviceTime}
                                    onChange={handleChange}
                                    required={true}
                                    disabled={loading}
                                />



                                <CustomReactSelect
                                    label="Vendor"
                                    name="vendor"
                                    value={vendorOptions.find(opt => opt.value === formData.vendor)}
                                    options={vendorOptions}
                                    onChange={handleSelectChange}
                                    placeholder='Select vendor'
                                    // required={true}
                                    isDisabled={loading}
                                />


                                <CustomReactSelect
                                    label="Vehicle"
                                    name="vehicleId"
                                    value={vehicleOptions.find(opt => opt.value === formData.vehicleId)}
                                    onChange={handleSelectChange}
                                    options={vehicleOptions}
                                    placeholder='Select vehicle'
                                    // required={true}
                                    isEditable={isVehicleEditable}
                                    isDisabled={loading}
                                />

                                <CustomInput
                                    label="Odometer"
                                    name="odometer"
                                    type="number"
                                    inputType="number"
                                    value={formData.odometer}
                                    onChange={handleChange}
                                    inputStyle={''}
                                    labelGap={'!gap-0.5'}
                                    labelStyle={'text-gray-700'}
                                    // required={true}
                                    maxLength={7}
                                    disabled={loading}
                                    unit={attributes?.distanceUnit}
                                />

                                <div className='sm:col-span-2 col-span-1 w-full'>
                                    <CustomReactSelect
                                        label="Types"
                                        name="types"
                                        value={typeOptions.filter(opt => formData.types.includes(opt.value))}
                                        options={typeOptions}
                                        onChange={handleMultiSelectChange}
                                        // required={true}
                                        isDisabled={loading}
                                        placeholder='Select types'
                                        isMulti={true}
                                    />
                                </div>

                                <div className='sm:col-span-2 flex w-full sm:flex-nowrap flex-wrap items-center gap-2'>
                                    <div className='sm:w-1/2 w-full relative'>
                                        <CustomInput
                                            label="Amount"
                                            name="amount"
                                            type="number"
                                            value={formData.amount}
                                            onChange={handleChange}
                                            inputStyle={' !py-[3px]'}
                                            labelStyle={'text-gray-700'}
                                            labelGap={'!gap-0.5'}
                                            required={true}
                                            decimalMaxDigits={10}
                                            allowDecimalFormat={true}
                                            disabled={loading}
                                            unit={attributes?.currency}
                                        />
                                        {formData.taxOption === 'Exclude' && formData.amount && (
                                            <p className="text-xs whitespace-nowrap absolute -bottom-4 left-0 text-gray-500 mt-1">
                                                Total with tax: {calculatedAmount()}
                                            </p>
                                        )}
                                    </div>

                                    <div className="flex items-center gap-2 sm:mt-0 mt-3">
                                        <div className='flex flex-col'>
                                            <label className="block text-sm text-gray-700 mb-[3px]">Tax</label>
                                            <TabToggle
                                                options={[
                                                    { label: 'Inc', value: 'Include' },
                                                    { label: 'Exc', value: 'Exclude' }
                                                ]}
                                                className={'!w-11 '}
                                                selected={formData.taxOption}
                                                onChange={(val) => setFormData(prev => ({
                                                    ...prev,
                                                    taxOption: val,
                                                    taxPercentage: val === 'Exclude' ? (prev.taxPercentage || '13') : ''
                                                }))}
                                                disabled={loading}
                                            />
                                        </div>

                                        {formData.taxOption === 'Exclude' && (
                                            <div className="relative w-28">
                                                <CustomInput
                                                    label="Tax %"
                                                    name="taxPercentage"
                                                    value={formData.taxPercentage}
                                                    onChange={handleChange}
                                                    type="number"
                                                    inputStyle={' sm:!py-[3px]'}
                                                    labelGap={'!gap-0.5'}
                                                    labelStyle={'text-gray-700 !text-sm'}
                                                    decimalMaxDigits={4}
                                                    allowDecimalFormat={true}
                                                    disabled={loading}
                                                />
                                                <span className="absolute right-[26px] top-[26px] text-gray-500 font-bold">%</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className={`${formData.taxOption === 'Exclude' ? 'mt-3' : ''} w-full sm:col-span-2`}>
                                    <CustomTextarea
                                        label="Note"
                                        name="note"
                                        value={formData.note}
                                        onChange={handleChange}
                                        placeholder=""
                                        rows={2}
                                        labelStyle={'text-gray-700'}
                                        maxLength={500}
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                            <div className="flex justify-end px-4">
                                <Button
                                    label={loading ? 'Saving...' : 'Save'}
                                    loading={loading}
                                    loadingLabel='Saving...'
                                    type='submit'
                                    disabled={loading || apiResponse.type === 'success'}
                                    className={`bg-btnBg rounded-lg !py-1 text-white `}
                                />
                            </div>
                        </>
            }


        </form>
    );
};

export default AddModal;